import { render, staticRenderFns } from "./OfferFeesForm.vue?vue&type=template&id=619bafc6&"
import script from "./OfferFeesForm.vue?vue&type=script&lang=js&"
export * from "./OfferFeesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports